export const Roles = [
    { name: 'Администратор', key: 'admin' },
    { name: 'Организатор', key: 'organizer' },
    { name: 'Команда - заявка', key: 'team-application' },
    { name: 'Команда - утв', key: 'team' },
    { name: 'Судья - заявка', key: 'judge-application' },
    { name: 'Судья - утв', key: 'judge' },
    { name: 'Секретарь', key: 'secretary' },
]
